module.exports = __webpack_public_path__ + "static/media/grataIconNotif.f2ec31de.svg";